import React from "react";
import { Container, Typography, Button, Grid2 as Grid, Card, CardContent, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Footer from "../layout/Footer";

const SaberMas = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container>
            <Grid size={12}>
              <Typography variant="h1" component="h1" gutterBottom>
                One Service Inversiones
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                Invierte con impacto. Participa en el crecimiento de una plataforma que transforma el acceso a servicios en
                Latinoamérica.
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                href="/" // Cambia esto por la URL deseada
                endIcon={<ArrowForwardIcon />}
              >
                Quiero invertir
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg">
        {/* ¿Por qué invertir? Section */}
        <Box className="section-moreAbout">
          <Grid container spacing={5}>
            <Grid size={12}>
              <Typography variant="h3" component="h2" gutterBottom>
                ¿Por qué invertir en One Service?
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Card className="card" sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" component="h3">
                    Accesible
                  </Typography>
                  <Typography component="p" color="text.secondary">
                    Participa con montos bajos y forma parte del crecimiento desde etapas tempranas.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Card className="card" sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" component="h3">
                    Transparente
                  </Typography>
                  <Typography color="text.secondary">
                    Conoce el destino de tu dinero y el impacto real que genera en la economía local.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Card className="card" sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" component="h3">
                    Con Propósito
                  </Typography>
                  <Typography color="text.secondary">
                    Impulsa una plataforma que conecta trabajo digno con necesidades reales.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* Así funciona Section */}
        <Box className="section-moreAbout">
          <Typography variant="h3" component="h2" gutterBottom mb={4}>
            Así funciona
          </Typography>
          <Box component="ol" sx={{ pl: 3 }}>
            <Typography component="li" sx={{ mb: 1 }}>
              <b>Regístrate</b> para conocer las oportunidades abiertas.
            </Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              <b>Elige</b> el monto con el que quieres participar.
            </Typography>
            <Typography component="li">
              <b>Haz seguimiento</b> a los resultados y al impacto de tu inversión.
            </Typography>
          </Box>
        </Box>

        {/* Preguntas frecuentes Section */}
        <Box className="section-moreAbout">
          <Typography variant="h3" component="h2" gutterBottom mb={4}>
            Preguntas frecuentes
          </Typography>
          <Box>
            <Typography variant="h6" component="p">
              ¿Es seguro invertir aquí?
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 4 }}>
              One Service Inversiones opera con transparencia y responsabilidad, presentando información clara y verificable.
            </Typography>
            <Typography variant="h6" component="p">
              ¿Qué tipo de retorno puedo esperar?
            </Typography>
            <Typography color="text.secondary">
              El retorno depende del crecimiento de la plataforma, que actualmente ya está operando y generando tracción.
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default SaberMas;